// Hounddale Custom Theme JS

// Legacy: previously set body.paddingTop = header.offsetHeight, which double-padded the page
// on top of the inline layout/theme.liquid rule `main { padding-top: var(--header-h) }` and
// produced the pink gap between the fixed header and the first section. We now only expose
// --header-height as a CSS variable for the sticky product gallery to reference, and leave
// vertical offsetting entirely to layout/theme.liquid's inline styles.
(function () {
  function setHeaderVar() {
    var header = document.querySelector('.site-header-fixed > .header') || document.querySelector('.site-header-fixed');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    if (bottom > 0) document.documentElement.style.setProperty('--header-height', Math.round(bottom) + 'px');
  }
  window.addEventListener('DOMContentLoaded', setHeaderVar);
  window.addEventListener('load', setHeaderVar);
  window.addEventListener('resize', setHeaderVar);
})();

// Countdown urgency bar — ticks down to a configurable end date, hides itself once it hits zero
(function () {
  var bar = document.querySelector('[data-countdown-end]');
  if (!bar) return;
  var endDate = new Date(bar.dataset.countdownEnd);
  if (isNaN(endDate.getTime())) return;

  var daysEl = bar.querySelector('[data-cd-days]');
  var hoursEl = bar.querySelector('[data-cd-hours]');
  var minsEl = bar.querySelector('[data-cd-mins]');
  var secsEl = bar.querySelector('[data-cd-secs]');

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  var timer;
  function tick() {
    var diff = endDate.getTime() - Date.now();
    if (diff <= 0) {
      bar.setAttribute('data-countdown-ended', '');
      clearInterval(timer);
      return;
    }
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    var secs = Math.floor((diff % 60000) / 1000);
    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minsEl) minsEl.textContent = pad(mins);
    if (secsEl) secsEl.textContent = pad(secs);
  }

  tick();
  timer = setInterval(tick, 1000);
})();

document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
    });
  }

  // Desktop nav dropdowns: open on hover (not just click), close when clicking elsewhere
  var isTouch = window.matchMedia('(hover: none)').matches;
  if (nav && !isTouch) {
    var navDetails = Array.prototype.slice.call(nav.querySelectorAll('details'));
    navDetails.forEach(function (d) {
      var closeTimer;
      d.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        navDetails.forEach(function (other) { if (other !== d) other.removeAttribute('open'); });
        d.setAttribute('open', '');
      });
      d.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { d.removeAttribute('open'); }, 150);
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (nav && !nav.contains(e.target)) {
      nav.querySelectorAll('details[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  // Product gallery: thumbnails + arrows + swipe
  var mainImg = document.querySelector('[data-main-image]');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
  var galleryIndex = 0;
  var countEl = document.querySelector('[data-gallery-count]');

  function showImage(i) {
    if (!mainImg || thumbs.length === 0) return;
    galleryIndex = (i + thumbs.length) % thumbs.length;
    mainImg.src = thumbs[galleryIndex].dataset.full;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    thumbs[galleryIndex].classList.add('active');
    if (countEl) countEl.textContent = (galleryIndex + 1) + ' / ' + thumbs.length;
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { showImage(i); });
  });

  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { showImage(galleryIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showImage(galleryIndex + 1); });

  var galleryMain = document.querySelector('.gallery-main');
  if (galleryMain && thumbs.length > 1) {
    var touchX = null;
    galleryMain.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) showImage(galleryIndex + (dx < 0 ? 1 : -1));
      touchX = null;
    }, { passive: true });
  }

  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) compareEl.textContent = opt.dataset.compare || '';

      if (opt.dataset.image) {
        var matchIndex = -1;
        thumbs.forEach(function (t, i) {
          if (matchIndex === -1 && opt.dataset.imageId && t.dataset.imageId === opt.dataset.imageId) {
            matchIndex = i;
          }
        });
        if (matchIndex !== -1) {
          showImage(matchIndex);
        } else if (mainImg) {
          mainImg.src = opt.dataset.image;
          thumbs.forEach(function (t) { t.classList.remove('active'); });
        }
      }
    });
  }

  var sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // Cart hover "Frequently Bought Together" — renders ONCE per page load and stays stable.
  // Reshuffling on every hover felt slot-machine-y; a full page navigation naturally picks
  // a fresh set. If the cart contents change (add/remove), we do NOT re-render — the strip
  // stays visually consistent within the same page view.
  (function () {
    var cartHover = document.querySelector('.cart-hover');
    var recsGrid = document.querySelector('[data-cart-recs-grid]');
    var dataEl = document.getElementById('cart-recs-data');
    if (!cartHover || !recsGrid || !dataEl) return;

    var allProducts = [];
    try { allProducts = JSON.parse(dataEl.textContent); } catch (e) {}

    function excludeIds() {
      return (cartHover.dataset.cartProductIds || '').split(',').filter(Boolean).map(Number);
    }

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
      }
      return a;
    }

    function renderRecs() {
      var exclude = excludeIds();
      var pool = allProducts.filter(function (p) { return exclude.indexOf(p.id) === -1; });
      var picks = shuffle(pool).slice(0, Math.min(8, pool.length));
      recsGrid.innerHTML = picks.map(function (p) {
        var safeTitle = String(p.title).replace(/"/g, '&quot;');
        var badge = p.comparePrice ? '<span class="cart-hover__rec-badge">Sale</span>' : '';
        var compare = p.comparePrice ? '<span class="cart-hover__rec-price-compare">' + p.comparePrice + '</span>' : '';
        return '<a class="cart-hover__rec-card" href="' + p.url + '">' +
          '<div class="cart-hover__rec-media">' + badge + '<img src="' + p.image + '" alt="' + safeTitle + '" loading="lazy"></div>' +
          '<div class="cart-hover__rec-title">' + p.title + '</div>' +
          '<div class="cart-hover__rec-price">' + p.price + compare + '</div>' +
          '</a>';
      }).join('');
    }

    // Fire once on load. No mouseenter/touchstart re-render — stable within the page view.
    renderRecs();

    var prevBtn = document.querySelector('[data-recs-prev]');
    var nextBtn = document.querySelector('[data-recs-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { recsGrid.scrollBy({ left: -150, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { recsGrid.scrollBy({ left: 150, behavior: 'smooth' }); });
  })();

  // Cart hover — live quantity/remove controls via Shopify's AJAX Cart API
  (function () {
    var panel = document.querySelector('.cart-hover__panel');
    var cartHover = document.querySelector('.cart-hover');
    if (!panel || !cartHover) return;

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function itemHtml(item) {
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-hover__item-variant">' + item.variant_title + '</div>' : '';
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + String(item.product_title).replace(/"/g, '&quot;') + '">' : '';
      return '<div class="cart-hover__item" data-line-key="' + item.key + '">' +
        imgHtml +
        '<div class="cart-hover__item-info">' +
          '<div class="cart-hover__item-title">' + item.product_title + '</div>' +
          variantHtml +
          '<div class="cart-hover__qty">' +
            '<button type="button" class="qty-btn" data-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
            '<span class="qty-value">' + item.quantity + '</span>' +
            '<button type="button" class="qty-btn" data-qty-increase aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-hover__item-price">' + formatMoney(item.line_price) + '</div>' +
        '<button type="button" class="cart-hover__remove" data-remove-item aria-label="Remove item">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>' +
        '</button>' +
      '</div>';
    }

    function renderCart(cart) {
      var itemsWrap = panel.querySelector('.cart-hover__items');
      var subtotalWrap = panel.querySelector('.cart-hover__subtotal');
      var actionsWrap = panel.querySelector('.cart-hover__actions');
      var emptyMsg = panel.querySelector('.cart-hover__empty');

      if (cart.item_count === 0) {
        if (itemsWrap) itemsWrap.remove();
        if (subtotalWrap) subtotalWrap.remove();
        if (actionsWrap) actionsWrap.remove();
        if (!panel.querySelector('.cart-hover__empty')) {
          var p = document.createElement('p');
          p.className = 'cart-hover__empty';
          p.textContent = 'Your cart is empty.';
          panel.insertBefore(p, panel.firstChild);
        }
      } else {
        if (emptyMsg) emptyMsg.remove();
        var html = cart.items.map(itemHtml).join('');
        if (itemsWrap) {
          itemsWrap.innerHTML = html;
        } else {
          itemsWrap = document.createElement('div');
          itemsWrap.className = 'cart-hover__items';
          itemsWrap.innerHTML = html;
          panel.insertBefore(itemsWrap, panel.firstChild);
        }
        if (subtotalWrap) {
          subtotalWrap.textContent = 'Subtotal: ' + formatMoney(cart.total_price);
        } else {
          subtotalWrap = document.createElement('div');
          subtotalWrap.className = 'cart-hover__subtotal';
          subtotalWrap.textContent = 'Subtotal: ' + formatMoney(cart.total_price);
          itemsWrap.insertAdjacentElement('afterend', subtotalWrap);
        }
        if (!actionsWrap) {
          actionsWrap = document.createElement('div');
          actionsWrap.className = 'cart-hover__actions';
          actionsWrap.innerHTML = '<a href="/cart" class="btn btn--secondary btn--block">View Cart</a>' +
            '<a href="/checkout" class="btn btn--block" style="margin-top:8px;">Checkout</a>';
          subtotalWrap.insertAdjacentElement('afterend', actionsWrap);
        }
      }

      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      cartHover.dataset.cartProductIds = cart.items.map(function (i) { return i.product_id; }).join(',');
    }

    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target)) return;
      var itemEl = e.target.closest('.cart-hover__item');
      if (!itemEl) return;

      var isDecrease = !!e.target.closest('[data-qty-decrease]');
      var isIncrease = !!e.target.closest('[data-qty-increase]');
      var isRemove = !!e.target.closest('[data-remove-item]');
      if (!isDecrease && !isIncrease && !isRemove) return;

      e.preventDefault();
      var key = itemEl.dataset.lineKey;
      var qtyEl = itemEl.querySelector('.qty-value');
      var currentQty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      var newQty = isRemove ? 0 : (isIncrease ? currentQty + 1 : Math.max(0, currentQty - 1));

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); })
        .catch(function () {});
    });
  })();

  // Mobile cart drawer — real open/close state, not a CSS ":hover"-on-tap simulation. Some
  // mobile browsers apply :hover briefly on tap before following a link, but this is
  // inconsistent across browsers/devices and wasn't reliably showing the panel at all on
  // many phones. Desktop keeps its native hover dropdown untouched (this only engages when
  // (hover: none) — a true touch device); tapping the cart icon there instead opens a real
  // bottom-sheet drawer with a backdrop and an explicit close button, toggled via the
  // .is-open class that assets/theme.css keys its (hover: none) drawer styles off of.
  (function () {
    var cartHover = document.querySelector('[data-cart-hover]');
    if (!cartHover) return;
    var trigger = cartHover.querySelector('[data-cart-trigger]');
    var closeBtn = cartHover.querySelector('[data-cart-close]');
    var backdrop = cartHover.querySelector('[data-cart-backdrop]');
    if (!trigger) return;

    function isTouch() { return window.matchMedia('(hover: none)').matches; }

    function openCart() {
      cartHover.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeCart() {
      cartHover.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', function (e) {
      if (!isTouch()) return; // desktop: normal link click straight to /cart, hover still shows the preview panel
      e.preventDefault();
      if (cartHover.classList.contains('is-open')) closeCart();
      else openCart();
    });
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
    if (backdrop) backdrop.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartHover.classList.contains('is-open')) closeCart();
    });
  })();

  // Mobile sticky Add to Cart bar — appears once the main Add to Cart button scrolls out of view
  (function () {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var mainAtcButton = document.querySelector('[data-atc-button]');
    var stickyButton = document.querySelector('[data-sticky-atc-button]');
    if (!stickyBar || !mainAtcButton) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.removeAttribute('data-visible');
          } else if (entry.boundingClientRect.top < 0) {
            stickyBar.setAttribute('data-visible', '');
          }
        });
      }, { threshold: 0 });
      observer.observe(mainAtcButton);
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        mainAtcButton.click();
      });
    }
  })();

  // Exit-intent popup — shows once per session, only if cart has items
  var exitPopup = document.getElementById('exit-popup');
  if (exitPopup) {
    var EXIT_KEY = 'hd_exit_popup_shown';
    var exitShown = false;
    try { exitShown = sessionStorage.getItem(EXIT_KEY) === '1'; } catch (e) {}

    var showExitPopup = function () {
      if (exitShown) return;
      exitShown = true;
      try { sessionStorage.setItem(EXIT_KEY, '1'); } catch (e) {}
      exitPopup.hidden = false;
    };
    var hideExitPopup = function () { exitPopup.hidden = true; };

    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && !e.toElement && e.clientY <= 0) {
        showExitPopup();
      }
    });

    var exitClose = exitPopup.querySelector('.exit-popup__close');
    var exitDismiss = exitPopup.querySelector('.exit-popup__dismiss');
    if (exitClose) exitClose.addEventListener('click', hideExitPopup);
    if (exitDismiss) exitDismiss.addEventListener('click', hideExitPopup);
    exitPopup.addEventListener('click', function (e) {
      if (e.target === exitPopup) hideExitPopup();
    });
  }
});
